import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Star, Quote, Mic } from "lucide-react";

const SPEAKING = "https://customer-assets-m6fa6gv7.emergentagent.net/job_equity-support/artifacts/rq6q0g0s_mabe%204.jpeg";

const TOPICS = [
    "Race, culture and belonging in health and social care",
    "Building psychologically safe, inclusive teams",
    "Turning WRES data into measurable culture change",
    "Leading with lived experience and authenticity",
];

const TESTIMONIALS = [
    { quote: "Herbie's keynote shifted the whole room from awareness to action.", name: "Head of EDI, Health & Social Care Provider" },
    { quote: "Honest, evidence-led and deeply human. Our leaders are still talking about it.", name: "NHS Trust People Director" },
];

export default function SpeakingServices() {
    return (
        <div className="bg-[#FBF7F0] text-[#14203A] font-sans min-h-screen" data-testid="speaking-page">
            <header className="border-b border-[#eee3d0]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                    <Link to="/" className="inline-flex items-center gap-2 text-[#14203A] font-semibold" data-testid="speaking-back"><ArrowLeft className="h-4 w-4" /> Back to EDI Connect</Link>
                    <Link to="/#contact"><Button className="bg-[#14203A] hover:bg-[#22304f] text-white rounded-full px-5" data-testid="speaking-enquire">Enquire</Button></Link>
                </div>
            </header>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-start">
                <div>
                    <span className="inline-flex items-center gap-2 text-[#C58B2B] font-semibold text-sm uppercase tracking-wider"><Mic className="h-4 w-4" /> Speaking, Writing & Keynotes</span>
                    <h1 className="font-display text-4xl sm:text-5xl font-bold mt-3 leading-tight">Keynotes that move rooms to action</h1>
                    <p className="mt-5 text-[#3d4657] leading-relaxed">Herbie Nyathi delivers evidence-led, lived-experience keynotes, workshops and writing that help health and social care organisations turn equity ambition into measurable culture change.</p>
                    <img src={SPEAKING} alt="Keynote speaking" className="rounded-2xl shadow-lg w-full h-72 object-cover mt-8" />
                    <ul className="mt-8 space-y-3">
                        {TOPICS.map((t) => (
                            <li key={t} className="flex items-start gap-3 text-[#14203A]"><Star className="h-4 w-4 text-[#C58B2B] shrink-0 mt-1" /> {t}</li>
                        ))}
                    </ul>
                    <div className="mt-8"><Link to="/#contact"><Button size="lg" className="bg-[#C58B2B] hover:bg-[#a9741f] text-white rounded-full px-8">Book Herbie to speak</Button></Link></div>
                </div>
                <div className="space-y-6 lg:pt-16">
                    {TESTIMONIALS.map((t) => (
                        <div key={t.name} className="bg-white rounded-2xl border border-[#eee3d0] p-6" data-testid="speaking-testimonial">
                            <Quote className="h-6 w-6 text-[#00A499]" />
                            <p className="mt-3 text-[#14203A] leading-relaxed font-display text-lg italic">"{t.quote}"</p>
                            <p className="mt-4 text-sm font-semibold text-[#5A6B7C]">— {t.name}</p>
                        </div>
                    ))}
                </div>
            </section>

            <footer className="bg-[#14203A] text-slate-400 py-6 text-center text-xs">© {new Date().getFullYear()} Coach Write Speak · Herbie Nyathi. All rights reserved.</footer>
        </div>
    );
}
